<template>
  <div>
    <v-container>
      <v-flex v-if="oneMatch">
        <share-link v-if="ended"></share-link>
        <match-score></match-score>
        <div v-if="!ended && is_owner">
          <control-squad></control-squad>
          <control-goal></control-goal>
          <control-card></control-card>
          <control-penalty v-if="oneMatch.data.attributes.round_kind=='finals'"></control-penalty>
          <end-match></end-match>
        </div>
        <v-container fluid>
          <v-card class="elevation-0">
            <v-card-title>
              <v-layout row wrap v-if="homeTeam && awayTeam" justify-space-around align-center>
                <v-flex xs12 md4 sm4 lg4 text-xs-center>
                  <event-list :goalPapers="goalsA" :cardPapers="cardsA"></event-list>
                </v-flex>
                <v-flex hidden-sm-and-up xs12 md4 sm4 lg4 text-xs-center ma-4>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 md4 sm4 lg4 text-xs-center>
                  <event-list :goalPapers="goalsB" :cardPapers="cardsB"></event-list>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-container>
      </v-flex>
    </v-container>
    <!-- <sponsor></sponsor> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    MatchScore: () => import("@/components/Championships/Paper/Score.vue"),
    EventList: () => import("@/components/Championships/Paper/Events.vue"),
    EndMatch: () => import("@/components/Championships/Paper/EndMatch.vue"),
    ControlGoal: () =>
      import("@/components/Championships/Paper/ControlGoal.vue"),
    ControlPenalty: () =>
      import("@/components/Championships/Paper/ControlPenalty.vue"),
    ControlSquad: () =>
      import("@/components/Championships/Paper/ControlSquad.vue"),
    ControlCard: () =>
      import("@/components/Championships/Paper/ControlCard.vue"),
    ShareLink: () => import("@/components/imports/_copyLink.vue"),
    Sponsor: () => import("@/components/Championships/Sponsor/Teste.vue")
  },

  data() {
    return {};
  },
  methods: {
    ...mapActions({
      showMatch: "Match/show"
    }),
    ...mapMutations({
      clearMatch: "Match/clearMatch"
    })
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    goalsA() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered;
    },
    goalsB() {
      var filtered = [];
      if (this.goalPapers) {
        filtered = this.goalPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered;
    },
    cardsA() {
      var filtered = [];
      if (this.cardPapers) {
        filtered = this.cardPapers.filter(obj => {
          return obj.champ_team_id === this.homeTeam.id;
        });
      }
      return filtered;
    },
    cardsB() {
      var filtered = [];
      if (this.cardPapers) {
        filtered = this.cardPapers.filter(obj => {
          return obj.champ_team_id === this.awayTeam.id;
        });
      }
      return filtered;
    },
    ended() {
      return this.oneMatch.data.attributes.ended;
    },
    is_owner() {
      let aux = false;
      if (
        this.user
        // this.user.id == this.oneChampionship.data.attributes.id
      ) {
        aux = true;
      }
      return aux;
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      user: state => state.Users.user,
      oneMatch: state => state.Match.oneMatch,
      goalPapers: state => state.Match.goalPapers,
      cardPapers: state => state.Match.cardPapers
    }),
    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    })
  },
  created() {
    this.showMatch(this.$router.currentRoute.params.id);
  },
  beforeRouteLeave(to, from, next) {
    this.clearMatch();
    next();
  },
  watch: {
    // data(nv, ov) {
    //   if (nv) {
    //   }
    // }
  }
};
</script>

<style scoped>
</style>